import { render } from "./TimerWidget.vue?vue&type=template&id=6ff292fb&scoped=true"
import script from "./TimerWidget.vue?vue&type=script&lang=js"
export * from "./TimerWidget.vue?vue&type=script&lang=js"

import "./TimerWidget.vue?vue&type=style&index=0&id=6ff292fb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ff292fb"

export default script